import React from 'react';
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../../shadcn/components/ui/input-otp';

const LENGTH = 6;
const digitsOnly = (text) => text.replace(/\D/g, '').slice(0, LENGTH);

export default function EmailCodeInput({ value, onChange, disabled, label, error, descriptionId }) {
  return <InputOTP autoFocus maxLength={LENGTH} value={value} disabled={disabled}
    pattern={REGEXP_ONLY_DIGITS} inputMode="numeric" autoComplete="one-time-code"
    pasteTransformer={digitsOnly} pushPasswordManagerStrategy="none" onChange={(next) => onChange(digitsOnly(next))}
    aria-label={label} aria-invalid={Boolean(error)} aria-describedby={descriptionId}>
    <InputOTPGroup>
      {Array.from({ length: LENGTH }, (_, index) =>
        <InputOTPSlot key={index} index={index} aria-invalid={Boolean(error) || undefined} className="size-10 text-base" />)}
    </InputOTPGroup>
  </InputOTP>;
}
